import React, { PureComponent } from 'react';
import ItinerarySlider from './itinerarySlider';
import { connect } from 'react-redux';
import dayjs from 'dayjs';


class Itinerary extends PureComponent {

  constructor(){
    super();
    this.onAddCity = this.onAddCity.bind(this);
    this.onItineraryClicked = this.onItineraryClicked.bind(this);
    this.onCityClicked = this.onCityClicked.bind(this);
  }

  onAddCity(){
    this.props.openEdit();
  }

  onItineraryClicked(){
    this.props.openModal();
  }

  onCityClicked(index, name){
    this.props.openCity(index, name);
  }

  render(){

    const { itineraries:{content:{nr_days, date_start, date_end}, sectors, cities, products, total_paid} } = this.props;

    return (
      <div className="cyao-itinerary" id="cyao-itinerary">
        <div className="row">
          <div className="column small-12 large-11 large-offset-0-5">
            <div className="row">
              <div className="column small-12">
                <h3 className="busabout-h3 uppercase no-margin">{nr_days + 1} Days Itinerary</h3>
                <p>
                  Starts in {sectors[0].city} on {dayjs(date_start).format('D MMMM')} and ends in {sectors[sectors.length -1].city} on {dayjs(date_end).format('D MMMM')}
                  <span className="cyao-itinerary-links add-city" onClick={this.onAddCity} style={{display: total_paid === "0.00" ? 'inline' : 'none' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path d="M384 250v12c0 6.6-5.4 12-12 12h-98v98c0 6.6-5.4 12-12 12h-12c-6.6 0-12-5.4-12-12v-98h-98c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h98v-98c0-6.6 5.4-12 12-12h12c6.6 0 12 5.4 12 12v98h98c6.6 0 12 5.4 12 12zm120 6c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-32 0c0-119.9-97.3-216-216-216-119.9 0-216 97.3-216 216 0 119.9 97.3 216 216 216 119.9 0 216-97.3 216-216z"/>
                    </svg>
                    Add city
                  </span>
                  <span className="cyao-itinerary-links view-itinerary" onClick={this.onItineraryClicked}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                      <path d="M531.004 34.78L397.62 94.04 184.791 33.231a31.997 31.997 0 0 0-21.788 1.527l-144 64A32 32 0 0 0 0 128v319.978c0 23.291 23.994 38.577 44.996 29.242l133.384-59.26 212.829 60.808a31.997 31.997 0 0 0 21.788-1.527l144-64A31.997 31.997 0 0 0 576 384V64.022c0-23.291-23.994-38.577-44.996-29.242zM192 68.571l192 54.857v320l-192-54.857v-320zM32 448V128l128-56.889v320L32 448zm512-64l-128 56.889v-320L544 64v320z"/>
                    </svg>
                    Itinerary / Accommodation
                  </span>
                </p>

              </div>
            </div>

            <div className="row">
              <div className="column small-12 itinerarySlider-wrapper">
                <ItinerarySlider onClick={this.onCityClicked} sectors={sectors} cities={cities} products={products} />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}


function mapStateToProps(state){
  return {
    itineraries:state.itineraries.data
  }
}

export default connect(mapStateToProps, null)(Itinerary);



// WEBPACK FOOTER //
// ./src/components/itinerary/components/itinerary.js